import React from "react";
import Tag from "./Tag";
import { AppState, NamedTagGroup } from "../model/AppState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./TagGroup.css";

type TagGroupProps = {
	group: NamedTagGroup;
	state: AppState;
	separator: boolean;
};

const TagGroup: React.FunctionComponent<TagGroupProps> = (
	props: TagGroupProps
) => {
	const setSelectionForAllTags = (select: boolean) => {
		props.group.tags.forEach((tag) => {
			props.state.setTagSelection(tag, select);
		});
	};

	return (
		<div className="TagGroup w3-container">
			{props.separator ? (
				<div className="TagGroup-separator"></div>
			) : (
				<></>
			)}
			<h3>
				<button
					className="w3-button w3-padding-small w3-right"
					onClick={() => setSelectionForAllTags(false)}
				>
					<FontAwesomeIcon icon={faTimes} />
				</button>
				<button
					className="w3-button w3-padding-small w3-right"
					onClick={() => setSelectionForAllTags(true)}
				>
					<FontAwesomeIcon icon={faCheck} />
				</button>
				<span className="TagGroup-name">{props.group.name}</span>
			</h3>
			<p>
				{props.group.tags.map((item) => (
					<Tag
						key={`${props.group.name}-${item}`}
						name={item}
						state={props.state}
					/>
				))}
			</p>
		</div>
	);
};

export default TagGroup;
